import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "@/i18n/LanguageContext";
import { ArrowLeft } from "lucide-react";

export default function LegalPage({ scope }) {
  const { t, prefix } = useLang();
  const doc = t(`legal.${scope}`);
  const sections = doc.sections || [];

  return (
    <main data-testid={`page-${scope}`} className="bg-white">
      <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8 py-16 lg:py-24">
        <Link
          to={prefix}
          data-testid="legal-back-home"
          className="inline-flex items-center gap-2 text-sm font-semibold text-teal-700 hover:text-teal-800"
        >
          <ArrowLeft className="h-4 w-4" />
          {t("legal.backHome")}
        </Link>
        <h1 className="mt-6 font-heading text-4xl sm:text-5xl font-extrabold tracking-tight text-slate-900">
          {doc.title}
        </h1>
        <p className="mt-3 text-sm text-slate-500">{t("legal.lastUpdated")}</p>
        <p className="mt-6 text-base leading-relaxed text-slate-700">
          {doc.intro}
        </p>

        <div className="mt-10 space-y-8">
          {sections.map((s, i) => (
            <section key={i}>
              <h2 className="font-heading text-xl sm:text-2xl font-bold text-slate-900">
                {s.heading}
              </h2>
              <p className="mt-2 text-base leading-relaxed text-slate-700">
                {s.body}
              </p>
            </section>
          ))}
        </div>
      </div>
    </main>
  );
}
